module.exports = __webpack_public_path__ + "assets/img/banner1.87489dc5.png";